import "core-js/modules/es6.array.find";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-right-doodle.svg';
import { mapGetters } from 'vuex';
import { FAQ, getQuestionsByLanguage } from '~/const/faq'; // import USE_MERCURE from '~/const/mercure';

var Cta = function Cta() {
  return import(
  /* webpackChunkName:"faq" */
  '~/components/atoms/Cta.vue');
};

var CtaLink = function CtaLink() {
  return import(
  /* webpackChunkName:"faq" */
  '~/components/atoms/CtaLink.vue');
};

var CloseButton = function CloseButton() {
  return import(
  /* webpackChunkName:"faq" */
  '~/components/atoms/CloseButton.vue');
};

export default {
  name: 'FaqLayer',
  components: {
    CtaLink: CtaLink,
    Cta: Cta,
    CloseButton: CloseButton
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    items: function items() {
      return [{
        text: getQuestionsByLanguage('frequently-asked-questions-01', this.locale.language).label,
        link: getQuestionsByLanguage('frequently-asked-questions-01', this.locale.language).url,
        tracking: {
          data: {
            event_category: 'Header',
            event_action: 'Aide et contact',
            event_label: getQuestionsByLanguage('frequently-asked-questions-01', this.locale.language).label
          }
        }
      }, {
        text: getQuestionsByLanguage('frequently-asked-questions-02', this.locale.language).label,
        link: getQuestionsByLanguage('frequently-asked-questions-02', this.locale.language).url,
        tracking: {
          data: {
            event_category: 'Header',
            event_action: 'Aide et contact',
            event_label: getQuestionsByLanguage('frequently-asked-questions-02', this.locale.language).label
          }
        }
      }, {
        text: getQuestionsByLanguage('frequently-asked-questions-03', this.locale.language).label,
        link: getQuestionsByLanguage('frequently-asked-questions-03', this.locale.language).url,
        tracking: {
          data: {
            event_category: 'Header',
            event_action: 'Aide et contact',
            event_label: getQuestionsByLanguage('frequently-asked-questions-03', this.locale.language).label
          }
        }
      }];
    },
    ctaUrl: function ctaUrl() {
      var _this = this;

      // if (USE_MERCURE(this.locale.iso)) {
      //   return `/${this.locale.market}/${this.locale.language}/help`;
      // }
      return FAQ.find(function (e) {
        return e.language === _this.locale.iso;
      }).url;
    },
    cta: function cta() {
      return {
        text: this.$t('cta'),
        link: this.ctaUrl,
        tracking: {
          data: {
            event_category: 'Header',
            event_action: 'Aide et contact',
            event_label: 'cta_Accès FAQ'
          }
        }
      };
    }
  })
};